export class OfferExpirationTime {
  maxHoursToDeparture: number;
  durationHours: number;
  expirationHours: number;
}
